var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import BarChartIcon from "@mui/icons-material/BarChart";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Card, CardContent, CardHeader, Grid, IconButton, Menu, MenuItem, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import { format } from "date-fns";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDeleteIntraSquadMatch } from "../api/IntraSquadMatchApiProvider";
import { useRetrieveUserIntraSquadMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveIntraSquadMatch, useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveTeamPreferences, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { findPlayerById } from "../players/utils";
import { formatScorer } from "../stats/ScorerFormatter";
import { findPlayerIntraSquadMatchStatByPlayerId } from "../stats/utils";
import { SquadCard } from "../teams/SquadCard";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
var IntraSquadMatch = function () {
    var _a, _b;
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _c = __read(React.useState(false), 2), showDelete = _c[0], setShowDelete = _c[1];
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _d = __read(useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var open = Boolean(anchorEl);
    var handleMenuOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var _e = useRetrieveUserIntraSquadMatchPermissions({ intraSquadMatchId: id }), userIntraSquadMatchPermissions = _e.data, userIntraSquadMatchPermissionsIsLoading = _e.isLoading, userIntraSquadMatchPermissionsError = _e.error;
    var _f = userIntraSquadMatchPermissions || {}, _g = _f.canModify, canModify = _g === void 0 ? false : _g, _h = _f.canView, canView = _h === void 0 ? false : _h;
    var _j = useRetrieveIntraSquadMatch({ id: id, enabled: canView }), intraSquadMatchIsLoading = _j.isLoading, intraSquadMatchError = _j.error, intraSquadMatch = _j.data;
    var _k = useRetrieveTeam({ id: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), useRetrieveTeamIsLoading = _k.isLoading, useRetrieveTeamError = _k.error, team = _k.data;
    var mutation = useDeleteIntraSquadMatch({
        intraSquadMatch: intraSquadMatch,
        team: team,
        onMutate: function () { },
        onSuccess: function () {
            return navigate("/teams/".concat(intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team));
        },
        onError: console.error,
    });
    var _l = useRetrieveTeamPreferences({ teamId: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), useRetrieveTeamPreferenceIsLoading = _l.isLoading, useRetrieveTeamPreferenceError = _l.error, teamPreference = _l.data;
    var _m = useRetrievePlayersByTeamId({ teamId: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), players = _m.data, playersError = _m.error, playersIsLoading = _m.isLoading;
    var getPlayer = findPlayerById(players || []);
    var getPlayerIntraSquadMatchStat = findPlayerIntraSquadMatchStatByPlayerId((intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.playerIntraSquadMatchStats) || []);
    var teamAPlayers = (_a = intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.teamAPlayers) === null || _a === void 0 ? void 0 : _a.map(getPlayer).filter(function (player) { return player !== undefined; });
    var teamBPlayers = (_b = intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.teamBPlayers) === null || _b === void 0 ? void 0 : _b.map(getPlayer).filter(function (player) { return player !== undefined; });
    var teamAScorers = teamAPlayers === null || teamAPlayers === void 0 ? void 0 : teamAPlayers.map(function (player) {
        var stats = getPlayerIntraSquadMatchStat(player.id);
        return formatScorer(player, stats);
    }).filter(function (scorer) { return scorer !== undefined; });
    var teamBScorers = teamBPlayers === null || teamBPlayers === void 0 ? void 0 : teamBPlayers.map(function (player) {
        var stats = getPlayerIntraSquadMatchStat(player.id);
        return formatScorer(player, stats);
    }).filter(function (scorer) { return scorer !== undefined; });
    if (userIntraSquadMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (!canView) {
        return _jsx(NotFound, {});
    }
    if (userIntraSquadMatchPermissionsError) {
        console.error(userIntraSquadMatchPermissionsError);
        return _jsx(ErrorView, { error: userIntraSquadMatchPermissionsError });
    }
    if (intraSquadMatchIsLoading ||
        mutation.isLoading ||
        playersIsLoading ||
        useRetrieveTeamPreferenceIsLoading ||
        useRetrieveTeamIsLoading) {
        return _jsx(Loading, {});
    }
    if (id === undefined) {
        return _jsx(NotFound, {});
    }
    if (useRetrieveTeamError ||
        intraSquadMatchError ||
        useRetrieveTeamPreferenceError ||
        playersError ||
        !intraSquadMatch ||
        !teamPreference ||
        !team) {
        return _jsx(ErrorView, {});
    }
    var handleCloseDeleteDialog = function () {
        setShowDelete(false);
    };
    var handleDelete = function () {
        mutation.mutate();
    };
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to delete match. Please try again!" }), _jsx(DeleteDialog, { open: showDelete, title: "Delete Intra-Squad Match?", onCancel: handleCloseDeleteDialog, onConfirm: handleDelete }), _jsxs(Card, { sx: { mb: 3 }, children: [_jsx(CardHeader, { title: _jsxs(Typography, { variant: "subtitle1", component: "div", align: "center", children: [_jsx("span", { style: { color: "#6c757d" }, children: format(new Date(intraSquadMatch.kickOff), "MMMM do yyyy @ H:mma") }), " ", "\u2022", " ", _jsx(Link, { style: { textDecoration: "none" }, to: "/teams/".concat(team.id), children: team.name }), " ", "Intra-Squad Match"] }), action: canModify ? (isMobile ? (_jsxs(Box, { sx: {
                                minWidth: 0,
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                            }, children: [_jsx(IconButton, { onClick: handleMenuOpen, children: _jsx(MoreVertIcon, {}) }), _jsxs(Menu, { anchorEl: anchorEl, open: open, onClose: handleMenuClose, anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" }, keepMounted: true, children: [_jsx(MenuItem, { component: Link, to: "/intra-squad-matches/".concat(id, "/stats/update/"), onClick: handleMenuClose, children: _jsx(BarChartIcon, {}) }), _jsx(MenuItem, { component: Link, to: "/intra-squad-matches/".concat(id, "/update"), onClick: handleMenuClose, children: _jsx(EditIcon, {}) }), _jsx(MenuItem, { onClick: function () {
                                                handleMenuClose();
                                                setShowDelete(true);
                                            }, children: _jsx(DeleteIcon, {}) })] })] })) : (_jsxs(Stack, { direction: "row", spacing: 1, children: [_jsx(IconButton, { component: Link, to: "/intra-squad-matches/".concat(id, "/stats/update/"), children: _jsx(BarChartIcon, {}) }), _jsx(IconButton, { component: Link, to: "/intra-squad-matches/".concat(id, "/update"), children: _jsx(EditIcon, {}) }), _jsx(IconButton, { onClick: function () { return setShowDelete(true); }, children: _jsx(DeleteIcon, {}) })] }))) : (_jsx(_Fragment, {})) }), _jsxs(CardContent, { children: [_jsxs(Box, { display: "flex", justifyContent: "center", alignItems: "baseline", flexWrap: "nowrap", sx: { gap: 1, whiteSpace: "nowrap" }, children: [_jsx(Typography, { variant: "h5", children: teamPreference.teamAName }), _jsx(Typography, { variant: "h4", children: intraSquadMatch.intraSquadMatchResult
                                            ? "".concat(intraSquadMatch.intraSquadMatchResult.teamAScore, " | ").concat(intraSquadMatch.intraSquadMatchResult.teamBScore)
                                            : "v" }), _jsx(Typography, { variant: "h5", children: teamPreference.teamBName })] }), _jsxs(Box, { mt: 1, display: "flex", justifyContent: "center", flexWrap: "nowrap", sx: { gap: 3 }, children: [_jsx(Typography, { variant: "body2", textAlign: "right", flex: 1, sx: { maxWidth: "45%" }, children: teamAScorers.join(", ") }), _jsx(Typography, { variant: "body2", textAlign: "left", flex: 1, sx: { maxWidth: "45%" }, children: teamBScorers.join(", ") })] })] })] }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, md: 6, children: _jsx(SquadCard, { title: _jsx(Typography, { align: "center", variant: "subtitle2", children: teamPreference.teamAName }), players: teamAPlayers || [] }) }), _jsx(Grid, { item: true, xs: 12, md: 6, children: _jsx(SquadCard, { title: _jsx(Typography, { align: "center", variant: "subtitle2", children: teamPreference.teamBName }), players: teamBPlayers || [] }) })] })] }));
};
export default IntraSquadMatch;
